module.exports = __webpack_public_path__ + "static/6-9f7e0f11f2cbd7101df75717f448b446.jpg";